import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN.json'
import en from './en.json'
import ar from './ar.json'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('xiongsu-language') || 'en',
  fallbackLocale: 'en',
  messages: { 'zh-CN': zhCN, en, ar }
})

export default i18n
